<template>
  <!-- <leo-banner
    ref="$banner"
    :timeout="15000"
    :borderColor="borderColor"
    :backgroundColor="backgroundColor"
    :icon="icon"
    :iconColor="iconColor"
    closeButton
  >
    <div class="leo-text-sm leo-text-secondary">
      {{ readMessage }}
    </div>
  </leo-banner> -->
  <div
    class="leo-flex leo-flex-col leo-justify-between"
    :class="
      isShow
        ? 'leo-banner--active leo-opacity-100 leo-visible leo-mt-2xl tablet:leo-mt-0'
        : 'leo-invisible leo-opacity-0 leo-absolute'
    "
    :style="{ top: `${positionTop}px` }"
  >
      <div class="leo-row tablet:leo-gap-md">
      <div class="leo-col-8 leo-px-xl desktop:leo-offset-2 tablet:leo-px-3xl">
        <div
          class="leo-text-left leo-rounded-xs leo-z-8 leo-py-lg leo-px-xl leo-flex leo-items-center leo-border-sm leo-border-solid"
          :class="{
            [`leo-border-${borderColor}`]: borderColor,
            [`leo-bg-${backgroundColor}`]: backgroundColor,
          }"
        >
          <div class="leo-mb-auto leo-mr-md">
            <leo-icon
              :type="`${icon}`"
              :color="`${iconColor}`"
              size="lg"
            ></leo-icon>
          </div>
          <div
            class="leo-banner--content leo-block leo-break-word tablet:leo-break-normal"
          >
            <div class="leo-text-sm leo-text-secondary">
              {{ readMessage }}
            </div>
          </div>
          <div
            class="leo-mb-auto leo-ml-md"
            v-if="closeButton"
            @click="handleClose"
          >
            <leo-icon
              class="leo-cursor-pointer"
              type="close"
              color="secondary"
              size="lg"
            ></leo-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { VueLeoIcon } from "@greateasternlife/leo-icon";
export default {
  name: "Alert",
  components:{
    "leo-icon": VueLeoIcon,
  },
  data() {
    return {
      isShow: false,
      closeButton: true,
      backgroundColor: "light-success", //lighter-red
      iconColor: "success", //primary
      icon: "action-completed",
      borderColor: "success",
      positionTop: 32,
      timeout: 20000,
    };
  },
  mounted() {
    // this.showBanner();
  },
  computed: {
    ...mapState("alert", {
      alert: (state) => state.alert,
      isActive: (state) => state.isActive,
    }),
    readMessage() {
      return this.alert?.message ?? "";
    },
    isAlertType() {
      return this.alert?.type;
    },
  },
  watch: {
    isActive(value) {
      this.isShow = value;
      this.showBanner();
      if (value) {
        // if (!this.closeButton) {
        //   this.closeAlertCall();
        // }
        this.closeAlertCall();
      }
    },
    isAlertType(oldVal, newVal) {
      if (oldVal !== undefined && newVal !== undefined) {
        if (oldVal !== newVal) {
          this.showBanner();
        }
      }
    },
  },
  methods: {
    showBanner() {
      if (this.alert && this.alert?.type === "error") {
        this.backgroundColor = "lighter-red";
        this.iconColor = "primary";
        this.icon = "alert";
        this.borderColor = "darker-red";
      } else {
        this.backgroundColor = "light-success";
        this.iconColor = "success";
        this.icon = "action-completed";
        this.borderColor = "success";
      }
    },
    handleClose() {
      this.isShow = false;
      this.closeAlert();
    },
    closeAlertCall() {
      clearTimeout(this.bannerTimeout);
      this.bannerTimeout = setTimeout(() => {
        this.isShow = false;
        this.closeAlert();
      }, this.timeout);
    },
    ...mapMutations({ closeAlert: "alert/CLOSE_ALERT" }),
  },
};
</script>
<style scoped>
.leo-banner--content {
  width: calc(100% - 20px);
}
.leo-break-word {
  word-break: break-word;
}
</style>
